// ts-check
/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { Button } from '@bottlebooks/gatsby-theme-base/src';
import { Trans } from '@lingui/macro';
import { Wine } from 'phosphor-react';
import React from 'react';
import { jsx } from 'theme-ui';
import useLink from '~/useLink';

export default function ProductCardActions({ product, ...rest }) {
  const link = useLink();
  return (
    <Button
      variant="outline"
      sx={{ display: 'flex', justifyContent: 'center' }}
      to={link.product(product)}
    >
      <Wine size={20} />
      <Trans>Go to product</Trans>
    </Button>
  );
}
